var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntroSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 261.355,
    height: 208.748,
    viewBox: "0 0 261.355 208.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-60.435 -150.879)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a0a0a0",
    d: "M186.406 283.391l12.6617-20.281 95.358 59.533-12.6616 20.2811z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.174 352.023l-.146.234c-3.994 6.4-11.121 9.155-15.919 6.16l-55.147-33.85 14.491-24.371 55.267 34.82c4.8 2.995 5.448 10.61 1.454 17.007z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.946 300.686l3.478 2.533 31.481-8.172-26.23-16.737z",
    fill: "#272525",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.965,
    cy: 71.965,
    r: 71.965,
    transform: "rotate(-45 335.1966 53.375)",
    fill: "#59595b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.908,
    cy: 61.908,
    r: 61.908,
    transform: "translate(100.3 190.744)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(108.941 196.815)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.654 53.343a43.6 43.6 0 0181.26-23.114c2.817 4.806 10.478.79 7.657-4.023A52.9 52.9 0 0041.016 1.151C19.098 5.816 2.927 24.651.292 46.671a47.824 47.824 0 00-.284 6.421c.085 5.554 8.732 5.847 8.646.252z",
    fill: "#fff",
    opacity: 0.22
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 5.696,
    cy: 5.696,
    r: 5.696,
    transform: "rotate(-.951 2331.5042 -5646.0834)",
    fill: "#fff",
    opacity: 0.31
  })), /*#__PURE__*/React.createElement("path", {
    d: "M248.693 323.76l13.788-23.191a1.805 1.805 0 00-.477-2.374l-.242-.179a1.806 1.806 0 00-2.636.543l-13.578 23.351a1.806 1.806 0 00.684 2.486l.032.017a1.805 1.805 0 002.429-.653z",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M222.602 253.095a61.266 61.266 0 11-8.218-30.67 61.731 61.731 0 018.218 30.67 1.648 1.648 0 003.294 0 64.555 64.555 0 10-20.458 47.146 65.283 65.283 0 0020.458-47.146 1.648 1.648 0 00-3.294 0z",
    fill: "#bfc0c1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroSearch);
export default __webpack_public_path__ + "static/media/intro__search.8e2c39a222eb4a8ff885bb1a79da35ab.svg";
export { ForwardRef as ReactComponent };